// Configuración de EmailJS para Emanta
// Para configurar EmailJS, necesitas:
// 1. Crear una cuenta en https://www.emailjs.com/
// 2. Crear un servicio de email (Gmail, Outlook, etc.)
// 3. Crear un template para el email
// 4. Obtener tu Public Key desde el dashboard

export const emailjsConfig = {
    // Service ID de EmailJS - obtenido del dashboard
    serviceId: process.env.VUE_APP_EMAILJS_SERVICE_ID || 'service_5ugw1ab',
    
    // Template ID para solicitudes de demo - obtenido del dashboard  
    demoTemplateId: process.env.VUE_APP_EMAILJS_DEMO_TEMPLATE_ID || 'template_kfqhakl',
    
    // Template ID para contacto general (opcional)
    contactTemplateId: process.env.VUE_APP_EMAILJS_CONTACT_TEMPLATE_ID || 'template_kfqhakl',
    
    // Public Key de EmailJS - obtenido del dashboard
    publicKey: process.env.VUE_APP_EMAILJS_PUBLIC_KEY || 'PlzlA_uq02yO8dYZr'
};

// Template de ejemplo para EmailJS
export const demoRequestTemplate = {
    // Variables que puedes usar en tu template de EmailJS:
    // {{to_name}} - Nombre del destinatario
    // {{from_name}} - Nombre del remitente  
    // {{from_email}} - Email del remitente
    // {{message}} - Mensaje personalizado
    // {{subject}} - Asunto del email
    // {{reply_to}} - Email para responder
    // {{company_name}} - Nombre de la empresa (si aplica)
    // {{phone}} - Teléfono (si aplica)
    // {{website}} - Sitio web (si aplica)
    // {{language}} - Idioma preferido
    // {{demo_date}} - Fecha preferida para demo (si aplica)
};

// Función helper para validar la configuración
export const validateEmailjsConfig = () => {
    const { serviceId, demoTemplateId, publicKey } = emailjsConfig;
    
    if (serviceId === 'YOUR_SERVICE_ID' || 
        demoTemplateId === 'YOUR_DEMO_TEMPLATE_ID' || 
        publicKey === 'YOUR_PUBLIC_KEY') {
        console.warn('⚠️ EmailJS no está configurado correctamente. Actualiza src/config/emailjs.config.js con tus credenciales reales.');
        return false;
    }
    
    // Validar que las credenciales no estén vacías
    if (!serviceId || !demoTemplateId || !publicKey) {
        console.warn('⚠️ Faltan credenciales de EmailJS.');
        return false;
    }
    
    return true;
};

// Instrucciones para configurar EmailJS
export const setupInstructions = `
🔧 INSTRUCCIONES PARA CONFIGURAR EMAILJS:

1. Crea una cuenta en https://www.emailjs.com/

2. Configura un servicio de email:
   - Ve a Email Services y añade un nuevo servicio
   - Conecta tu Gmail, Outlook u otro proveedor
   - Copia el Service ID

3. Crea un template:
   - Ve a Email Templates y crea un nuevo template
   - Usa las variables del template (ej: {{from_email}}, {{message}})
   - Ejemplo de template para demo:
     
     Subject: Nueva solicitud de demo - {{from_email}}
     
     Hola {{to_name}},
     
     Has recibido una nueva solicitud de demo desde la web de Emanta.
     
     Detalles:
     - Email: {{from_email}}
     - Nombre: {{from_name}}
     - Mensaje: {{message}}
     - Idioma: {{language}}
     - Fecha: {{request_date}}
     
     Por favor, contacta al usuario para programar la demo.
     
     Saludos,
     Sistema Emanta

4. Obtén tu Public Key:
   - Ve a Account > General
   - Copia tu Public Key

5. Actualiza las variables de entorno:
   - Crea un archivo .env.local en la raíz del proyecto
   - Añade:
     VUE_APP_EMAILJS_SERVICE_ID=tu_service_id
     VUE_APP_EMAILJS_DEMO_TEMPLATE_ID=tu_template_id  
     VUE_APP_EMAILJS_PUBLIC_KEY=tu_public_key

6. O actualiza directamente este archivo con tus credenciales
`;